import React from 'react';
import { Box, Select } from "@amzn/awsui-components-react";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import { CopyToClipboard } from "../common/CopyToClipboard";
import { GAMMA_STAGE, PROD_STAGE } from "../../constants";

interface DashboardStageSelectorProps {
  stage: string;
  setStage: (stage: string) => void;
  getShareUrl: (() => Promise<string>) | null;
}

export const DashboardStageSelector: React.FC<DashboardStageSelectorProps> = ({
  stage,
  setStage,
  getShareUrl,
}) => {
  return (
    <SpaceBetween size="xs">
      <Box>Environment</Box>
      <div style={{ display: "flex", gap: "8px", alignItems: "flex-start" }}>
        <div style={{ flex: 1 }}>
          <Select
            selectedOption={{ label: stage, value: stage }}
            onChange={({ detail }) => {
              const newStage = detail.selectedOption.value || stage;
              setStage(newStage);
            }}
            options={[
              { label: PROD_STAGE, value: PROD_STAGE },
              { label: GAMMA_STAGE, value: GAMMA_STAGE },
            ]}
            selectedAriaLabel="Selected"
            placeholder="Select a stage"
            ariaRequired={true}
          />
        </div>
        <CopyToClipboard getContent={getShareUrl || (async () => "")} disabled={!getShareUrl}>
          Share link with filters
        </CopyToClipboard>
      </div>
    </SpaceBetween>
  );
};
